import React from 'react'
import qs from 'query-string'
import template from 'es6-dynamic-template'
import {Window, Support} from 'common/components'
import errors from 'common/config/messages.json'
import providers from 'common/config/providers.json'


export default class App extends React.Component {
    getProviderTitle = provider => {
        const foundObject = provider && providers.find(i => i.url === provider)
        return foundObject ? foundObject.title : provider
    }

    parseProviderName = identifier => {
        if (!identifier) { return null }

        const provider = identifier.split('/').pop()
        return this.getProviderTitle(provider)
    }

    mapProvidersToTitles = (keys) => {
        const safeKeys = Array.isArray(keys) ? keys : [keys]
        return safeKeys.map(this.getProviderTitle).join(', ')
    }


    parseBody = (input, defaults = {}) => {
        const body = input ? JSON.parse(input) : {}
        return {
            ...body,
            field: body.field || body.Required,
            provider: this.getProviderTitle(body.provider) ||
                this.parseProviderName(defaults.provider),
            identityProvider: this.mapProvidersToTitles(body.identityProvider)
        }
    }


    errorByType = (type, body) => (
        errors[type] && {
            ...errors[type],
            ...(body && {
                content: template(errors[type].content, body),
                title: template(errors[type].title, body)
            })
        }
    )

    errorByCode = (code) => (
        code && errors['AuthCode.General']
    )

    errorByStatus = (status) => (
        errors[`Unknown.${status}`]
    )

    errorOther = () => (
        errors['Error']
    )


    render() {
        const {
            status, path, type,
            error, error_code, body
        } = qs.parse(window.location.search)

        const parsedBody =
            this.parseBody(body, {provider: path})

        const message =
            this.errorByType(`Error.${type || error}`, parsedBody) ||
            this.errorByCode(error_code) ||
            this.errorByStatus(status) ||
            this.errorOther()

        const errorStatus = (
            status && /^\d+$/.test(status) && status.length === 3 &&
            (status.startsWith('4') || status.startsWith('5')) && status
        ) || 'Системна Помилка'

        return (
            <div className="content">
                <Window message={null} picture='failure'>
                    <div>
                        <h1>{errorStatus}</h1>
                        <h2>{message.title}</h2>
                        <p style={{whiteSpace: 'pre-wrap'}}>{message.content}</p>
                        <br />
                    </div>
                </Window>
                <Support />
            </div>
        )
    }
}